module.exports = __webpack_public_path__ + "img/logo.25bb8956.png";